import React from "react";

const MultiSelectCheckboxSeverity = ({
  data,
  selected,
  setSelected,
  disable,
}) => {
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    const ids = data.map((item) => item?.id);
    setSelected((prev) => (prev.length === ids.length ? [] : ids));
  };

  console.log("data----->", data);

  return (
    <div className="multi-select-container">
      <div className="d-flex ac-jb mb-3 px-2">
        <select
          className="form-select p-2 "
          style={{ width: "200px" }}
          disabled={disable ? true : false}
        >
          <option hidden value="">
            Select Items
          </option>
        </select>

        <button
          className="select-btnt"
          onClick={handleSelectAll}
          disabled={disable ? true : false}
        >
          {selected?.length === data?.length ? "Unselect All" : "Select All"}
        </button>
      </div>

      <div className="checkbox-list px-3">
        {data?.map((item, ind) => (
          <div
            key={ind}
            className="d-flex align-items-center justify-content-between gap-2 mb-2"
          >
            <label
              className="d-flex align-items-center gap-2 col-md-10"
              style={{ cursor: "pointer" }}
            >
              <input
                type="checkbox"
                checked={selected.includes(item?.id)}
                onChange={() => handleSelect(item?.id)}
                disabled={disable ? true : false}
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  accentColor: "#852e59",
                }}
              />
              <span className="f4">{item?.name}</span>
            </label>
            <div style={{ width: "50px" }}>
              {ind == 0 && <span className="f4">Severity</span>}
              <input
                className="input-box text-center w-100 f4 mt-2"
                value={item?.severity}
                disabled
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectCheckboxSeverity;
